import clsx from 'clsx'
import { CaretDown, CloseIcon, PlusIcon } from '../icons'

const ActionButton = ({
	size = 'medium',
	type = 'caret',
	disabled = false,
	...props
}) => {
	return (
		<button
			type="button"
			className={clsx(
				size === 'small' ? 'h-8 w-8' : 'h-12 w-12',
				disabled === Boolean(true)
					? 'border-uiTertiaryDark/50 text-uiTertiaryDark/50 dark:border-white/50 dark:text-white/50'
					: 'border-uiTertiaryDark text-uiTertiaryDark hover:bg-textPrimaryLight hover:text-textPrimaryDark active:bg-textPrimaryLight active:text-textPrimaryDark dark:border-white dark:text-white hover:dark:border-uiTertiaryLight dark:hover:bg-textPrimaryDark hover:dark:text-textPrimaryLight active:dark:border-uiTertiaryLight active:dark:bg-uiTertiaryLight active:dark:text-textPrimaryLight',
				'flex items-center justify-center rounded-full border outline-0 ring-0',
			)}
			{...props}
		>
			{type === 'caret' && <CaretDown size="medium" />}
			{type === 'plus' && <PlusIcon />}
			{type === 'close' && <CloseIcon />}
		</button>
	)
}

export default ActionButton
